var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailGradientIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 75.294 51.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_62);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_62",
    x1: 8.74153,
    y1: -3.34778,
    x2: 66.55278,
    y2: 54.46347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13444,
    stopColor: "#00fb70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30662,
    stopColor: "#00ee80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49932,
    stopColor: "#00da9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#00bebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92445,
    stopColor: "#009aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008cff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.097,0H9.197A9.20773,9.20773,0,0,0,0,9.197V41.919a9.20773,9.20773,0,0,0,9.197,9.197h56.9a9.20773,9.20773,0,0,0,9.197-9.197V9.198A9.20667,9.20667,0,0,0,66.097,0ZM61.603,6,37.647,21.434,13.691,6Zm4.494,39.117H9.197A3.201,3.201,0,0,1,6,41.92V9.368l29.796,19.16c.04.025.083.042.124.065.043.024.087.047.131.069a3.45546,3.45546,0,0,0,.712.278c.025.007.05.01.075.016a3.5189,3.5189,0,0,0,.807.102h.006a3.46487,3.46487,0,0,0,.807-.102c.025-.006.05-.009.075-.016a3.47715,3.47715,0,0,0,.712-.278c.044-.022.088-.045.131-.069.041-.023.084-.04.124-.065L69.296,9.368V41.919A3.20363,3.20363,0,0,1,66.097,45.117Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailGradientIc);
export default __webpack_public_path__ + "static/media/mail-gradient-ic.bcebc883bc992374a84d3bb6c01bf2e7.svg";
export { ForwardRef as ReactComponent };